import { RefObject, useEffect } from "react";

const SHEET_OVERLAP_PX = 93;
const HERO_PREFERRED_RATIO = 0.52;

/** Drives the hero height from the sheet's measured content so CSS can animate the change. */
const useMobileAuthHeroHeight = (sheetRef: RefObject<HTMLElement>) => {
    useEffect(() => {
        const sheet = sheetRef.current;
        if (!sheet) return;

        const applyHeroHeight = () => {
            const viewportHeight = window.innerHeight;
            const preferred = viewportHeight * HERO_PREFERRED_RATIO;
            const leftover = viewportHeight - sheet.offsetHeight + SHEET_OVERLAP_PX;
            const heroHeight = Math.max(0, Math.min(preferred, leftover));

            document.documentElement.style.setProperty("--mobile-auth-hero-height", `${heroHeight}px`);
        };

        applyHeroHeight();

        const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(applyHeroHeight);
        observer?.observe(sheet);
        window.addEventListener("resize", applyHeroHeight);

        return () => {
            observer?.disconnect();
            window.removeEventListener("resize", applyHeroHeight);
            document.documentElement.style.removeProperty("--mobile-auth-hero-height");
        };
    }, [sheetRef]);
};

export default useMobileAuthHeroHeight;
